<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container">
        <a class="navbar-brand" href=""
        @click.prevent="goPageHandler('Home'); gaEvent(gaCategory, 'LOGO_header');">
        <img src="@/assets/nav_logo_pc.png" alt="固齒佳logo">
        <h1>固齒佳 開運笑起來</h1>
        </a>
        <button class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation">
            <span class="navbar-toggler-bar"></span>
            <span class="navbar-toggler-bar"></span>
            <span class="navbar-toggler-bar"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
                <li class="nav-item"
                :class="{'active': isActive('Home'), 'pc-hide': l.isPCHide}"
                v-for="(l, idx) in list"
                :key="idx">
                <a href=""
                class="nav-link"
                :class="l.class"
                @click.prevent="goPageHandler(l.link); gaEvent(gaCategory, l.label);"
                v-html="l.name">
                </a>
                </li>
            </ul>
        </div>
    </div>
  </nav>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'MainNav',
    data() {
        return {
            gaCategory: 'header_btn',
            list: [
                {
                    name: '開運笑起來',
                    class: '',
                    link: 'Activity',
                    label: 'smile_test',
                    isPCHide: true,
                },
                {
                    name: '<span class="pc-hide">開運笑起來・</span>活動辦法',
                    class: '',
                    link: 'Info',
                    label: 'activity',
                    isPCHide: true,
                },
                {
                    name: '<span class="pc-hide">開運笑起來・</span>中獎名單',
                    class: '',
                    link: 'Award',
                    label: 'winner',
                    isPCHide: true,
                },
                {
                    name: '產品介紹',
                    class: '',
                    link: 'Product',
                    label: 'products',
                    isPCHide: true,
                },
                {
                    name: `<span class="fb-icon"></span>
                    <span class="pc-hide">日本獅王 台灣官方粉絲團</span>`,
                    class: 'outside-link',
                    link: 'https://www.facebook.com/lifelovelion/',
                    label: 'LION_FB',
                    isPCHide: false,
                },
                {
                    name: `<span class="shop-icon"></span>
                    <span class="pc-hide">日本獅王 台灣官方旗艦館</span>`,
                    class: 'outside-link',
                    link: 'http://bit.ly/2FyF7qW',
                    label: 'LION_EC',
                    isPCHide: false,
                },
            ],
        };
    },
    props: {
    },
    mounted() {},
    methods: {
        goPageHandler(link) {
            if (window.innerWidth < 992) {
                document.querySelector('#navbarNav').classList.forEach((item) => {
                    if (item === 'show') {
                        document.querySelector('.navbar-toggler').click();
                        // eslint-disable-next-line
                        return;
                    }
                });
            }

            if (link === this.$route.name) return;

            // if (link === 'Award') {
            //     this.commonAlert('中獎名單於2020/2/12公布，敬請期待');
            //     return;
            // }

            if (link.match('http')) {
                window.open(link, '_blank');
                return;
            }

            this.goPage(link);
        },
        isActive(name) {
            if (!this.controllerName) return false;
            return this.controllerName.match(name);
        },
    },
    mixins: [mixinMethod],
};
</script>
